import { Texture } from "pixi.js"

// Shared background for the "ambient" banners (important + hero): a horizontal alpha
// gradient that is transparent at both left/right edges and `centerAlpha` black across a
// wide center plateau. Baked from a 2D canvas into a single static texture (cheap for weak
// GPUs). Callers cache the returned texture and reuse it — the strip width is fixed.
//
// Falls back to Texture.WHITE when no 2D context is available (e.g. the jest canvas mock);
// in that case the caller should tint (0x000000) + alpha the Sprite itself so it still
// reads as a dark strip.
export const buildAmbientStripTexture = (width: number, height: number, centerAlpha: number): Texture => {
    try {
        const canvas = document.createElement("canvas")
        canvas.width = Math.max(1, Math.round(width))
        canvas.height = Math.max(1, Math.round(height))
        const ctx = canvas.getContext("2d")
        if (!ctx) {
            return Texture.WHITE
        }
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0)
        gradient.addColorStop(0.0, "rgba(0,0,0,0)")
        gradient.addColorStop(0.18, `rgba(0,0,0,${centerAlpha})`)
        gradient.addColorStop(0.82, `rgba(0,0,0,${centerAlpha})`)
        gradient.addColorStop(1.0, "rgba(0,0,0,0)")
        ctx.fillStyle = gradient
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        return Texture.from(canvas)
    } catch (e) {
        return Texture.WHITE
    }
}
